import { Phone } from "lucide-react";
import { PHONE } from "@/content";

export const Monogram = () => (
  <img src="/logos/jz-mark.jpg" alt="Jamal Zgugu logo" width="80" height="80" className="w-14 h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 shrink-0 object-contain mix-blend-multiply" data-testid="site-logo" />
);

export const Nav = ({ t }) => {
  const links = ["about", "roles", "credentials", "contact"];
  return (
    <nav className="max-w-6xl mx-auto px-5 sm:px-6 py-5 md:py-6 flex items-center justify-between gap-3 sm:gap-6" data-testid="main-nav">
      <a href="#top" className="flex items-center gap-2.5 sm:gap-4 min-w-0" data-testid="nav-home-link">
        <Monogram />
        <span className="latin whitespace-nowrap text-[24px] sm:text-3xl lg:text-4xl leading-none" dir="ltr" data-testid="site-name">Jamal Zgugu</span>
      </a>
      <div className="hidden lg:flex gap-8 lb">
        {links.map((k) => (
          <a
            key={k}
            href={`#${k}`}
            className="transition-colors duration-200 hover:text-brass"
            data-testid={`nav-${k}-link`}
          >
            {t.nav[k]}
          </a>
        ))}
      </div>
      <a
        href={`tel:${PHONE.replace(/\s/g, "")}`}
        className="flex items-center gap-2 sv text-[15px] whitespace-nowrap border border-ink/40 px-3 sm:px-4 py-2 transition-colors duration-200 hover:bg-ink hover:text-paper"
        data-testid="nav-phone-link"
        aria-label={`Call ${PHONE}`}
      >
        <Phone size={16} />
        <span className="hidden sm:inline">{PHONE}</span>
      </a>
    </nav>
  );
};
